module.exports = __webpack_public_path__ + "img/news9-2.b7fbf42e.png";